export const colors = {
  primary: {
    main: '#1976d2',
    hover: '#1565c0',
    light: '#e3f2fd',
    dark: '#0d47a1',
  },
  secondary: {
    main: '#dc004e',
  },
  success: {
    main: '#2e7d32',
    light: '#e8f5e8',
    dark: '#1b5e20',
  },
  error: {
    main: '#c62828',
    light: '#ffebee',
    dark: '#b71c1c',
  },
  warning: {
    main: '#ed6c02',
    light: '#fff3e0',
    dark: '#e65100',
  },
  info: {
    main: '#0288d1',
    light: '#e1f5fe',
  },
  background: {
    primary: '#ffffff',
    secondary: '#fafafa',
    tertiary: '#f5f5f5',
    card: '#f8fafc',
    hover: '#f9fafb',
  },
  border: {
    main: '#e0e0e0',
    light: '#f3f4f6',
    medium: '#e5e7eb',
  },
  text: {
    primary: '#111827',
    secondary: '#6b7280',
    tertiary: '#374151',
    disabled: '#9ca3af',
  },
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },
  purple: {
    main: '#9c27b0',
  },
  common: {
    white: '#ffffff',
    black: '#000000',
  },
  slate: {
    200: '#e2e8f0',
  },
  alpha: {
    black04: 'rgba(0,0,0,0.04)',
    black05: 'rgba(0,0,0,0.05)',
    black06: 'rgba(0,0,0,0.06)',
    black08: 'rgba(0,0,0,0.08)',
    black12: 'rgba(0,0,0,0.12)',
    black30: 'rgba(0,0,0,0.30)',
    white60: 'rgba(255,255,255,0.60)'
  }
};